// TermsOfService.jsx
export default function TermsOfService() {
  return (
    <section className="mx-auto max-w-4xl px-6 py-16">
      <h1 className="text-4xl font-bold mb-6">Terms of Service</h1>
      <p className="mb-4">
        By using our website, you agree to these Terms of Service. Please read
        them carefully.
      </p>
      <h2 className="text-2xl font-semibold mt-6 mb-2">Use of the Website</h2>
      <p className="mb-4">
        You may use this website for lawful purposes only. You agree not to
        engage in any activity that could harm the website, its users, or our
        business.
      </p>
      <h2 className="text-2xl font-semibold mt-6 mb-2">
        Intellectual Property
      </h2>
      <p className="mb-4">
        All content on this website, including text, images, logos, and design,
        is owned by us or our licensors and is protected by intellectual
        property laws. You may not reproduce or use our content without
        permission.
      </p>
      <h2 className="text-2xl font-semibold mt-6 mb-2">
        Limitation of Liability
      </h2>
      <p className="mb-4">
        We are not responsible for any damages or losses resulting from your use
        of this website. Use the website at your own risk.
      </p>
      <h2 className="text-2xl font-semibold mt-6 mb-2">Changes to Terms</h2>
      <p className="mb-4">
        We may update these Terms of Service at any time. The latest version
        will be posted on this page.
      </p>
      <h2 className="text-2xl font-semibold mt-6 mb-2">Contact Us</h2>
      <p>
        If you have any questions about these Terms of Service, please contact
        us through our website.
      </p>
    </section>
  );
}
